import { NavLink } from 'react-router-dom';
import ArtworkIcon from "src/assets/all-icons/artwork-icon.jsx";
import BoardIcon from "src/assets/all-icons/board-icon.jsx";

import ArtlistIcon from '@/assets/all-icons/artlist-icon';
import SaveArtworkIcon from '@/assets/all-icons/save-artwork-icon';
import useTranslations from '@/i18n/useTranslations';
import ThoughtIcon from '@/shared-components/icons/components/artwork/ThoughtIcon';
import Text from '@/shared-components/text/components/Text';

import './styles/ActivityMenu.css';

function ActivityMenuNavLink({ to, Icon, iconClassName, text, replace }) {
  return (
    <>
      <NavLink className={({ isActive }) =>`activity-menu__menu-link${isActive ? " active" : ""}`} to={to} state={{ from: true }} replace={replace}>
        <div className="activity-menu__menu-link-icon-container">
          <Icon className={`activity-menu__menu-link-icon ${iconClassName}`}/>
        </div>
        <Text className="activity-menu__menu-link-text">{text}</Text>
      </NavLink>
    </>
  );
}

export default function ActivityMenu({ replace=false }) {
  const t = useTranslations('common.profile.activity.menu');

  return (
    <>
      <div className="activity-menu__container">
        <ActivityMenuNavLink 
          to="/profile/activity/liked-artworks" 
          iconClassName="liked-artworks" 
          text={t('liked_artworks')}
          Icon={ArtworkIcon}
          replace={replace}
        />

        <ActivityMenuNavLink 
          to="/profile/activity/liked-thoughts" 
          iconClassName="liked-thoughts" 
          text={t('liked_thoughts')}
          Icon={ThoughtIcon}
          replace={replace}
        />

        <ActivityMenuNavLink 
          to="/profile/activity/liked-artlists" 
          iconClassName="liked-artlists"
          text={t('liked_artlists')}
          Icon={ArtlistIcon}
          replace={replace}
        />

        <ActivityMenuNavLink 
          to="/profile/activity/liked-posts" 
          iconClassName="liked-posts" 
          text={t('liked_posts')}
          Icon={BoardIcon}
          replace={replace}
        />

        <ActivityMenuNavLink
          to="/profile/activity/liked-articles"
          iconClassName="liked-posts"    // same styling as “Liked posts”
          text={t('liked_articles')}
          Icon={BoardIcon}               // same icon
          replace={replace}
        />

        <ActivityMenuNavLink 
          to="/profile/activity/saved-artworks" 
          iconClassName="saved-artworks" 
          text={t('saved_artworks')}
          Icon={SaveArtworkIcon}
          replace={replace}
        />

      </div>
    </>
  );
}
